export const BADGE = 'BADGE';


// WEBPACK FOOTER //
// ./src/store/modules/badge/mutation-types.js